import * as React from 'react';

function VerticalLineIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={1}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path stroke="#DCE3EE" strokeLinecap="round" d="M.5.5v19" />
    </svg>
  );
}

export default VerticalLineIcon;
